import React from 'react';

import { Card, Row, Space } from 'antd';
import { Outlet } from 'react-router-dom';
import { Color } from 'src/styles';

import { MTypography } from '../../MTypography/MTypography';

import * as Styles from './InformationPanel.styles';

export const InformationPanel = () => {
  const [title, setTitle] = React.useState<string>();

  return (
    <Row justify={'center'}>
      <Space direction='vertical' size={30}>
        <MTypography variant='h3' weight='semibold' align='center' color={Color.Brand6} className={Styles.title}>
          {title}
        </MTypography>
        <Card className={Styles.cardWrapper}>
          <Outlet context={[title, setTitle]} />
        </Card>
      </Space>
    </Row>
  );
};

export default InformationPanel;
